import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const selector = '.js-block-testimonials';
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const eventName = new CustomEvent('testimonialsInit');
	const { TestimonialsSlider } = await import('./testimonials-slider');

	[...elements].forEach((element) => {
		const testimonialsSlider = new TestimonialsSlider({
			element,
			blockClass: 'block-testimonials',
			nextElement: `${selector}-next`,
			prevElement: `${selector}-prev`,
			paginationElement: `${selector}-pagination`,
			eventName,
		});

		testimonialsSlider.init();
	});
});
